module.exports = __webpack_public_path__ + "img/pethouse31.81ae6f7a.jpg";